import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./userStoreModule";

export default function useUser() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'user',
        label: 'пользователь',
      },
      { key: 'email',
        label: 'email',
      },
      { key: 'worker',
        label: 'должность',
      },
  ])

  const setupData = {
      formModel: {
          username: "",
          email: "",
          first_name: "",
          last_name: "",
          worker_name: "",
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
